import { Toaster } from "sonner";
import { useToastLane } from "../lib/toastLane";

/**
 * AppToaster — the app's one toast outlet (v149.72).
 *
 * Top right everywhere, as before. On a screen that reserves a lane for
 * them (the page designer — see `lib/toastLane.js`) the toasts are the
 * same toasts in the same corner; only their distance from the top comes
 * from that screen (`--toast-lane-top`), so they sit in the room it made.
 * It stays ONE `<Toaster>`, so a toast on screen survives the change.
 */
export default function AppToaster() {
  const lane = useToastLane();
  if (lane !== "reserved") {
    return <Toaster position="top-right" richColors />;
  }
  return (
    <Toaster
      position="top-right"
      richColors
      offset={{ top: "var(--toast-lane-top, 24px)" }}
      mobileOffset={{ top: "var(--toast-lane-top, 16px)" }}
    />
  );
}
